import axios from "axios";

const state = {
  menus: []
};

const getters = {
  menus: state => state.menus
};

const actions = {
  getMenus: ({ commit }, payload) => {
    return axios
      .get(
        process.env.VUE_APP_API_URL +
          "/menu/list.php?tahun=" +
          payload.year +
          "&kategori=" +
          payload.category +
          "&jurusan=" +
          payload.jurusan +
          "&prodi=" +
          payload.prodi
      )
      .then(res => {
        commit("SET_MENUS", res.data);
        return res.data;
      });
  },
  setMenus({ commit }, payload) {
    commit("SET_MENUS", payload);
  }
};

const mutations = {
  SET_MENUS: (state, payload) => {
    state.menus = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
